<div>
  <div style="float: right;">
    <i class="material-icons __close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
  <div>
    <textarea [(ngModel)]="newComment" #ta autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" ng-model-options="{ updateOn: 'blur' }"></textarea>
    <button *ngIf="isedit" mat-raised-button class="button" color="warn" (click)="updateComment()" [class.loading]="savingComment" [disabled]="savingComment"><span>{{'Save Comment' | translate | async}}</span></button>
  </div>
</div>
